export function ThaiNumberToText(Number) {
	Number = Number.replace(/๐/gi, '0');
	Number = Number.replace(/๑/gi, '1');
	Number = Number.replace(/๒/gi, '2');
	Number = Number.replace(/๓/gi, '3');
	Number = Number.replace(/๔/gi, '4');
	Number = Number.replace(/๕/gi, '5');
	Number = Number.replace(/๖/gi, '6');
	Number = Number.replace(/๗/gi, '7');
	Number = Number.replace(/๘/gi, '8');
	Number = Number.replace(/๙/gi, '9');
	return toBahtText(Number);
}

export function toBahtText(number) {
	let Number = CheckNumber(number.toFixed(2));
	let NumberArray = ["ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ"]
	let DigitArray = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"]
	let BahtText = "";
	if (isNaN(Number)) {
		return "ข้อมูลนำเข้าไม่ถูกต้อง";
	} else {
		if ((Number - 0) > 9999999.9999) {
			return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
		} else {
			Number = Number.split(".");
			if (Number[1].length > 0) {
				Number[1] = Number[1].substring(0, 2);
			}
			let NumberLen = Number[0].length - 0;
			let prevTmp = 0;
			for (let i = 0; i < NumberLen; i++) {
				let tmp = Number[0].substring(i, i + 1) - 0;
				if (tmp !== 0) {
					if ((i === (NumberLen - 1)) && (tmp === 1)) {
						if (NumberLen === 1 || prevTmp === 0) {
							BahtText += "หนึ่ง";
						} else {
							BahtText += "เอ็ด";
						}
					} else if ((i === (NumberLen - 2)) && (tmp === 2)) {
						BahtText += "ยี่";
					} else if ((i === (NumberLen - 2)) && (tmp === 1)) {
						BahtText += "";
					} else {
						BahtText += NumberArray[tmp];
					}
					BahtText += DigitArray[NumberLen - i - 1];
				}
				prevTmp = tmp;
			}
			BahtText += "บาท";
			if ((Number[1] === "0") || (Number[1] === "00")) {
				BahtText += "ถ้วน";
			} else {
				prevTmp = 0;
				let DecimalLen = Number[1].length - 0;
				for (let j = 0; j < DecimalLen; j++) {
					let tmp = Number[1].substring(j, j + 1) - 0;
					if (tmp !== 0) {
						if ((j === (DecimalLen - 1)) && (tmp === 1)) {
							if (DecimalLen === 1 || prevTmp === 0) {
								BahtText += "หนึ่ง";
							} else {
								BahtText += "เอ็ด";
							}
						} else
							if ((j === (DecimalLen - 2)) && (tmp === 2)) {
								BahtText += "ยี่";
							} else
								if ((j === (DecimalLen - 2)) && (tmp === 1)) {
									BahtText += "";
								} else {
									BahtText += NumberArray[tmp];
								}
						BahtText += DigitArray[DecimalLen - j - 1];
					}
					prevTmp = tmp;
				}
				BahtText += "สตางค์";
			}
			return BahtText;
		}
	}
}

function CheckNumber(Number) {
	let decimal = false;
	Number = Number.toString();
	Number = Number.replace(/ |,|บาท|฿/gi, '');
	for (let i = 0; i < Number.length; i++) {
		if (Number[i] === '.') {
			decimal = true;
		}
	}
	if (decimal === false) {
		Number = Number + '.00';
	}
	return Number
}